/**
 * COMM-R1.2 / R1.3 — soft Home card for UNKNOWN marketing permission (not a second consent gate).
 */
import type { StoreV2Lang } from "./store-v2-locale.js";

export function HomeMarketingOptInCardV2(props: {
  lang: StoreV2Lang;
  onAccept: () => void;
  onDismiss: () => void;
}) {
  const { lang, onAccept, onDismiss } = props;
  return (
    <section
      className="sv2-recovery-card sv2-home-marketing-optin"
      data-testid="sv2-home-marketing-optin"
      aria-label={lang === "en" ? "Telegram updates" : "Оновлення в Telegram"}
    >
      <strong style={{ display: "block", marginBottom: 6 }}>
        {lang === "en" ? "🎁 Don’t miss new arrivals" : "🎁 Не пропускайте новинки"}
      </strong>
      <p className="sv2-muted" style={{ margin: "0 0 10px", fontSize: 13, lineHeight: 1.4 }}>
        {lang === "en"
          ? "Get personal selections, new arrivals, and unfinished-purchase reminders in Telegram."
          : "Отримуйте в Telegram персональні добірки, новинки та нагадування про незавершені покупки."}
      </p>
      <div className="sv2-home-marketing-optin-actions">
        <button type="button" className="sv2-cta" data-testid="sv2-home-marketing-optin-accept" onClick={onAccept}>
          {lang === "en" ? "Turn on" : "Увімкнути"}
        </button>
        <button
          type="button"
          className="sv2-cta sv2-secondary"
          data-testid="sv2-home-marketing-optin-dismiss"
          onClick={onDismiss}
        >
          {lang === "en" ? "Not now" : "Не зараз"}
        </button>
      </div>
    </section>
  );
}
